import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotRanking() {
  const ranked = [...comics].sort((a, b) => b.views - a.views).slice(0, 10);

  const formatViews = (views: number) => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="mb-6 md:mb-8">
          <h2 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">
            热门排行榜
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            无删减韩国漫画排行榜 · 基于真实阅读数据
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-5">
          {ranked.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="flex items-center gap-3 md:gap-5 p-3 md:p-4 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center flex-shrink-0">
                {index < 3 ? (
                  <span className={`text-lg md:text-xl font-bold ${
                    index === 0 ? 'text-accent-500' : index === 1 ? 'text-secondary-500' : 'text-accent-700'
                  }`}>
                    {index + 1}
                  </span>
                ) : (
                  <span className="text-base md:text-lg font-semibold text-foreground-400">
                    {index + 1}
                  </span>
                )}
              </div>
              <div className="w-12 h-16 md:w-14 md:h-20 rounded overflow-hidden flex-shrink-0">
                <img
                  src={comic.coverImage}
                  alt={`${comic.title} - 韩国漫画排行第${index + 1}名`}
                  title={`${comic.title} 排名第${index + 1}`}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="mt-0.5 text-xs text-foreground-500">{comic.author}</p>
                <div className="mt-1 flex items-center gap-2 md:gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500" />
                    {comic.rating}
                  </span>
                  <span>{formatViews(comic.views)} 阅读</span>
                  <span className="hidden sm:inline text-primary-600">{comic.status}</span>
                </div>
              </div>
              <div className="flex-shrink-0">
                <i className="ri-arrow-right-s-line text-foreground-400 text-xl" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}